module.exports = __webpack_public_path__ + "img/follow-one@3x.98dc4ea6.png";